import { isEmptyDash } from "../constant";
import { axiosServices } from "./axiosServices";

export const vendorServices = {
  createVendorInvite,
  getVendorList,
  getVendorListFiltered,
  getExistingVendorList,
  getExistingVendorListFiltered,
  getVendorDetails,
  getInternalVendorDetailsForStep,
  getAssignSteps,
  evaluateStep,
  approverAssign,
  getDocument,
  getVendorDetailsById,
  planFactoryVisit,
  reIinviteVendor,
  getVendorDetailsResponseById1,
  getInternalVendorDetailsResponseForStep
};

function createVendorInvite(bodyData) {
  return axiosServices
    .postAxios("/v1/common/invite/vendor", bodyData)
    .then((res) => {
      // console.log(res);
      return res;
    });
}

function getVendorList(param) {
  return axiosServices
    .getAxios(`/v1/common/vendor-list${param}`)
    .then((res) => {
      // console.log(res);
      return res;
    });
}

function getVendorListFiltered(param) {
  return axiosServices
    .getAxios(`/v1/common/vendor-list/filter${param}`)
    .then((res) => {
      // console.log(res);
      return res;
    });
}

function getExistingVendorList(param) {
  return axiosServices
    .getAxios(`/v1/common/vendor-list/existing${param}`)
    .then((res) => {
      // console.log(res);
      return res;
    });
}

function getExistingVendorListFiltered(param) {
  return axiosServices
    .getAxios(`/v1/common/vendor-list/filter${param}`)
    .then((res) => {
      // console.log(res);
      return res;
    });
}

function getVendorDetails(param) {
  return axiosServices.getAxios(`/v1/vendor/details`).then((res) => {
    // console.log(res);
    return res;
  });
}

function getVendorDetailsById(param) {
  return axiosServices.getAxios(`/v1/internal/vendors${param}`).then((res) => {
    // console.log(res);
    return res;
  });
}

function getInternalVendorDetailsForStep(vendorId, param) {
  return axiosServices
    .getAxios(`/v1/internal/vendors/${vendorId}/responses${param}`)
    .then((res) => {
      // console.log(res);
      return res;
    });
}
function getAssignSteps(param) {
  let data = isEmptyDash(param) ? "" : param;
  return axiosServices.getAxios(`/v1/internal/steps/assignees${data}`).then((res) => {
    // console.log(res);
    return res;
  });
}
function evaluateStep(bodyData, stepId) {
  return axiosServices
    .postAxios(`/v1/internal/steps/evaluate?stepId=${stepId}`, bodyData)
    .then((res) => {
      // console.log(res);
      return res;
    });
}
function approverAssign(bodyData, stepId) {
  return axiosServices
    .postAxios(`/v1/internal/steps/assign-approver?stepId=${stepId}`, bodyData)
    .then((res) => {
      // console.log(res);
      return res;
    });
}

function getDocument(bodyData) {
  return axiosServices
    .postAxios("/v1/internal/vendors/documents", bodyData)
    .then((res) => {
      // console.log(res);
      return res;
    });
}


function planFactoryVisit(bodyData) {
  return axiosServices
    .postAxios("/v1/engineering/factory-visit/is-required", bodyData)
    .then((res) => {
      // console.log(res);
      return res;
    });
}
function reIinviteVendor(bodyData) {
  return axiosServices
    .postAxios("/v1/common/invite/vendor/reinvite", bodyData)
    .then((res) => {
      // console.log(res);
      return res;
    });
}

function getVendorDetailsResponseById1(param) {
  return axiosServices.getAxios(`/v1/vendor/onboarding/responses`).then((res) => {
    // console.log(res);
    return res;
  });
}

function getInternalVendorDetailsResponseForStep(vendorId, param) {
  return axiosServices
    .getAxios(`/v1/vendor/onboarding/responses${param}`)
    .then((res) => {
      // console.log(res);
      return res;
    });
}

// function handleResponse(response) {
//     console.log(response.response);
//     if (response.response.status == 200) {
//         return response.response.data;
//     } else {
//         console.log(`Request failed with status code ${response.response.status}`);
//         return response.response.data;
//     }
//     // return response.text().then(text => {
//     //     const data = text && JSON.parse(text);
//     //     if (!response.ok) {
//     //         if (response.status === 401) {
//     //             // auto logout if 401 response returned from api
//     //             // logout();
//     //             window.location.reload(true);
//     //             // location.reload(true);
//     //         }

//     //         const error = (data && data.message) || response.statusText;
//     //         return Promise.reject(error);
//     //     }

//     //     return data;
//     // });
// }
